import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { Amplify } from 'aws-amplify';
import hljs from 'highlight.js/lib/core';
import json from 'highlight.js/lib/languages/json';
import { marked } from 'marked';

import version from '@optical/version';

import { appConfig } from './app/app.config';
import { RootComponent } from './app/root.component';
import { environment } from './environments/environment';

// Configure the Markdown parser
marked.use({
  breaks: true,
});

// Register languages to highlight
hljs.registerLanguage('json', json);

Amplify.configure({
  Auth: {
    Cognito: {
      loginWith: {
        oauth: {
          domain: environment.cognito.domain,
          redirectSignIn: [environment.cognito.redirectSignIn],
          redirectSignOut: [environment.cognito.redirectSignOut],
          responseType: 'code',
          scopes: ['email', 'openid', 'aws.cognito.signin.user.admin'],
        },
      },
      userPoolClientId: environment.cognito.clientId,
      userPoolId: environment.cognito.userPoolId,
    },
  },
});

if (environment.sentry.enabled) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    release: `compete-vision-app@${version}`,
    environment: environment.sentry.environment,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.httpClientIntegration(),
      Sentry.replayIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [environment.apiUrl],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    beforeSend(event: Sentry.ErrorEvent) {
      // Scrub sensitive data from the event
      return event;
    },
  });
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(RootComponent, appConfig).catch((err) => console.error(err));
